import React from 'react';
import * as S from './style';

function LoadingPage({ text }: { text?: string }) {
  return (
    <S.Overflow>
      <S.LoadingIcon />
      {text}
    </S.Overflow>
  );
}

export default LoadingPage;
